var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "50%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onHandleClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "contents" },
            [
              _c(
                "el-form",
                {
                  ref: "refCityForm",
                  staticClass: "demo-cityForm",
                  attrs: { "label-width": "170px", model: _vm.cityForm },
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.cityForm.is_premiums_deduction,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.cityForm,
                                "is_premiums_deduction",
                                $$v
                              )
                            },
                            expression: "cityForm.is_premiums_deduction",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("扣费"),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("不扣费"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.cityForm.is_premiums_deduction == 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "截止时间" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd",
                              placeholder: "选择日期",
                              "picker-options": _vm.pickerOptions,
                            },
                            model: {
                              value:
                                _vm.cityForm.premiums_deduction_deadline_date,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.cityForm,
                                  "premiums_deduction_deadline_date",
                                  $$v
                                )
                              },
                              expression:
                                "cityForm.premiums_deduction_deadline_date",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onHandleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.submitLoading },
                  on: { click: _vm.onHandleSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }